import React from 'react';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';

const useStyles = makeStyles(() => ({
    body: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '16px',
        padding: '64px 32px 32px 32px'
    },
    subtext: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        textAlign: 'center'
    },
    btnDiv: {
        display: 'flex',
        justifyContent: 'center'
    },
    closeButton: {
        color: '#7378E8',
        fontSize: '18px',
        fontWeight: 700,
        textTransform: 'none !important'
    }
}));

const titleColors = {
    yellow: '#7A4406',
    red: '#F5577A',
    green: '#1B9757'
} as const;

export type AlertBodyTitleColor = keyof typeof titleColors;

type AlertBodyProps = {
    title: string;
    subtext: string | null;
    titleColor?: AlertBodyTitleColor;
    closeButtonText?: string;
    onClose?: () => void;
};

const AlertBody: React.FC<AlertBodyProps> = ({
    title,
    subtext,
    titleColor = 'yellow',
    closeButtonText,
    onClose
}) => {
    const classes = useStyles();
    const titleStyle = {
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: '32px',
        textAlign: 'center' as const,
        color: titleColors[titleColor]
    };

    return (
        <div className={classes.body}>
            <span style={titleStyle}>{title}</span>
            {subtext && <span className={classes.subtext}>{subtext}</span>}
            {closeButtonText != null && onClose != null && (
                <div className={classes.btnDiv}>
                    <Button className={classes.closeButton} onClick={onClose}>
                        {closeButtonText}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AlertBody;
